module.exports = __webpack_public_path__ + "img/zempie_game_icon.089470bc.svg";